import { useCallback, useEffect, useRef } from 'react';
import { action } from 'mobx';
import useStore from "./useStore.js";
export var useFilter = name => {
  var store = useStore();
  var setFilterState = useCallback(action("useFilter('".concat(name, "').setFilterState"), nValue => {
    store.filterMap[name].setState(nValue, store);
  }), [name]);
  var filter = store.filterMap[name];
  var filterState = filter === null || filter === void 0 ? void 0 : filter.state;
  var applyListenerRef = useRef(null);
  var createListenerRef = useRef(null);
  var setOnApplySnapshot = useCallback(action("useFilter('".concat(name, "').setOnApplySnapshot"), nListener => {
    if (applyListenerRef.current) {
      store.filterMap[name].offApplySnapshot(applyListenerRef.current);
    }
    if (nListener) {
      store.filterMap[name].onApplySnapshot(nListener);
    }
    applyListenerRef.current = nListener;
  }), [name]);
  var setOnCreateSnapshot = useCallback(action("useFilter('".concat(name, "').setOnCreateSnapshot"), nListener => {
    if (createListenerRef.current) {
      store.filterMap[name].offCreateSnapshot(createListenerRef.current);
    }
    if (nListener) {
      store.filterMap[name].onApplySnapshot(nListener);
    }
    createListenerRef.current = nListener;
  }), [name]);
  useEffect(() => {
    return action("useFilter('".concat(name, "').unmount"), () => {
      if (applyListenerRef.current) {
        // remove listener from filter when component is unmounted
        store.filterMap[name].offApplySnapshot(applyListenerRef.current);
      }
      if (createListenerRef.current) {
        store.filterMap[name].offCreateSnapshot(createListenerRef.current);
      }
    });
  }, []);
  return {
    filter,
    filterState,
    setFilterState,
    setOnApplySnapshot,
    setOnCreateSnapshot,
    get params() {
      return filter.exposeParams();
    }
  };
};
export default useFilter;
//# sourceMappingURL=useFilter.js.map